import DefaultLayout from '@/layouts/DefaultLayout.vue'

const Projects = () => import('@/pages/merch/project/Projects.vue')
const PersonalAccount = () => import('@/pages/merch/personalAccount/PersonalAccount.vue')
const PersonalData = () => import('@/pages/merch/personalAccount/PersonalData.vue')
const ChooseMonth = () => import('@/pages/merch/personalAccount/MonthOfActs.vue')
const Act = () => import('@/pages/merch/personalAccount/Act.vue')
const ChooseYear = () => import('@/pages/merch/personalAccount/ChooseYear.vue')
const Agreement = () => import('@/pages/merch/personalAccount/Agreement.vue')
const MonthOfAgreement = () => import('@/pages/merch/personalAccount/MonthOfAgreement')
const ChooseAgreementYear = () => import('@/pages/merch/personalAccount/ChooseAgreementYear')

export default {
    path: '/personalAccount',
    component: DefaultLayout,
    children: [
    {
        path: '',
        component: Projects,
        children: [
          {
            path: '',
            name: 'Личный кабинет',
            meta: {
              label: "Личный кабинет",
              title: "Личный кабинет"
            },
            component: PersonalAccount
          },
          {
            path: 'personalData',
            name: 'Личные данные',
            meta: {
              label: "Личные данные",
              title: "Личные данные",
               breadcrumb: [
                { name: 'Личный кабинет', link: '/personalAccount' }
              ],
            },
           
            component: PersonalData
          },

          {
            path: 'agreementYears',
            name: 'Выбор года (договор)',
            meta: {
              label: "Выбор года (договор)",
              title: "Выбор года (договор)",
               breadcrumb: [
                { name: 'Личный кабинет', link: '/personalAccount' }
              ],
            },
           
            component: ChooseAgreementYear
          },
          {
            path: 'agreementYears/:year/months',
            name: 'Выбор месяца (договор)',
            meta: {
              label: "Выбор месяца (договор)",
              title: "Выбор месяца (договор)",
               breadcrumb: [
                { name: 'Выбор года (договор)', link: '/agreementYears' }
              ],
            },
            component: MonthOfAgreement,
            props: true
          },
          
          {
            path: 'agreementYears/:year/months/:mid/agreement',
            name: 'Договоры',
            meta: {
              label: "Договоры",
              title: "Договоры",
               breadcrumb: [
                { name: 'Выбор месяца (договор)', link: 'agreementYears/:year/months' }
              ],
            },
            component: Agreement,
            props: true
          },
          
          {
            path: 'yearsAct',
            name: 'Выбор года (акт)',
            meta: {
              label: "Выбор года (акт)",
              title: "Выбор года (акт)",
               breadcrumb: [
                { name: 'Личный кабинет', link: '/personalAccount' }
              ],
            },
           
            component: ChooseYear
          },
          {
            path: 'yearsAct/:year/months',
            name: 'Выбор месяца  (акт)',
            meta: {
              label: "Выбор месяца (акт)",
              title: "Выбор месяца (акт)",
               breadcrumb: [
                { name: 'Выбор года (акт)', link: '/yearsAct' }
              ],
            },
            component: ChooseMonth,
            props: true
          },
          
          {
            path: 'yearsAct/:year/months/:mid/acts',
            name: 'Акты',
            meta: {
              label: "Акты",
              title: "Акты",
               breadcrumb: [
                { name: 'Выбор месяца  (акт)', link: 'yearsAct/:year/months' }
              ],
            },
            component: Act,
            props: true
          },
        ]
    }
  ]
}